"use client"

import { VerifiedIcon } from "@/app/icons/verified"

export function GachaAuthenticityLabel() {
  return (
    <div className="inline-flex w-fit shrink-0 items-center gap-1.5 font-headline text-brand text-sm">
      <span>Guaranteed Authenticity</span>
      <VerifiedIcon className="h-4 w-4 shrink-0 text-brand" />
    </div>
  )
}
